export const categories = [
  {
    slug: 'glacier-source',
    name: '冰川之源系列',
    subtitle: '源自万年冰川深处的纯净',
    description: '冰川之源系列是昆仑雪的旗舰产品线，水源取自昆仑山脉海拔6000米以上的万年冰川融水。经过数万年的自然过滤与矿化，每一滴水都蕴含着大自然的精华。水质清冽甘甜，富含钙、镁、钾等多种有益矿物质，pH值天然弱碱性，是追求极致纯净生活品质的理想之选。',
    imageSeq: 'cat-glacier-01',
    products: [
      {
        name: '冰川之源·经典款 500ml',
        description: '日常饮用首选，500ml便携装，适合办公、出行、运动等场景。瓶身采用流线型设计，握感舒适，随时随地补充纯净能量。',
        price: '¥28',
        features: ['天然弱碱性', '富含矿物质', '便携500ml', 'BPA-free瓶身'],
        imageSeq: 'prod-glacier-classic',
      },
      {
        name: '冰川之源·尊享款 1L',
        description: '家庭聚会、商务宴请的理想之选。1L大容量设计，满足多人饮用需求。瓶身采用高端水晶质感设计，彰显品位。',
        price: '¥48',
        features: ['大容量1L', '水晶质感瓶身', '商务宴请首选', '送礼佳品'],
        imageSeq: 'prod-glacier-premium',
      },
      {
        name: '冰川之源·迷你装 330ml',
        description: '精致小巧，随身携带无负担。330ml迷你装，适合儿童、女性日常饮用，也是会议、宴会的最佳伴手礼。',
        price: '¥18',
        features: ['迷你精致', '儿童适用', '会议伴手礼', '轻巧便携'],
        imageSeq: 'prod-glacier-mini',
      },
    ],
  },
  {
    slug: 'snow-spring',
    name: '雪山灵泉系列',
    subtitle: '雪山深处的灵性之水',
    description: '雪山灵泉系列源自昆仑山海拔4000米处的深层岩层泉水，经过数千年岩层过滤，水质清澈透明，口感柔滑细腻。该系列主打日常健康饮水概念，以亲民的价格让更多人享受到来自雪山的纯净滋养。富含锶、偏硅酸等对人体有益的微量元素。',
    imageSeq: 'cat-spring-01',
    products: [
      {
        name: '雪山灵泉·标准装 550ml',
        description: '日常健康饮水的性价比之选，550ml标准装，适合全家人日常饮用。简约环保包装设计，践行绿色生活理念。',
        price: '¥12',
        features: ['高性价比', '家庭日常', '环保包装', '柔滑口感'],
        imageSeq: 'prod-spring-standard',
      },
      {
        name: '雪山灵泉·家庭装 5L',
        description: '大家庭必备，5L经济实惠家庭装。适用于日常饮用、烹饪、泡茶等全场景使用，让全家人都能享受纯净雪山泉水。',
        price: '¥38',
        features: ['5L大容量', '全场景使用', '经济实惠', '全家共享'],
        imageSeq: 'prod-spring-family',
      },
    ],
  },
  {
    slug: 'limited-edition',
    name: '珍藏限量系列',
    subtitle: '只为少数人珍藏',
    description: '珍藏限量系列是昆仑雪的最高端产品线，每一瓶水都来自昆仑山特定冰川区域的特定年份融水。瓶身由国际知名设计师倾力打造，采用手工吹制水晶玻璃瓶，配以24K金箔装饰。每一瓶都有独立编号和收藏证书，全球限量发售，是身份与品位的象征。',
    imageSeq: 'cat-limited-01',
    products: [
      {
        name: '珍藏限量·昆仑之巅 750ml',
        description: '全球限量999瓶，手工水晶瓶身，24K金箔装饰。每一滴水都来自海拔7000米以上特定冰川，限量编号，配有专属收藏证书。',
        price: '¥1,988',
        features: ['限量编号', '水晶玻璃瓶', '24K金箔', '收藏证书'],
        imageSeq: 'prod-limited-peak',
      },
      {
        name: '珍藏限量·雪域珍藏 750ml',
        description: '年度限量版，瓶身设计融合昆仑山文化与现代艺术美学。每年仅发售一次，是高端收藏家和鉴赏家的必收之选。',
        price: '¥3,688',
        features: ['年度限量', '艺术设计', '收藏级', '独立编号'],
        imageSeq: 'prod-limited-collection',
      },
    ],
  },
];

export const articles = [
  {
    slug: 'kunlun-glacier-water-health-benefits',
    title: '昆仑山冰川水：大自然的健康密码',
    excerpt: '冰川水被誉为"生命之水"，昆仑山万年冰川融水为何被称为最纯净的水源？本文从科学角度解析冰川水的独特健康价值。',
    content: `昆仑山，被誉为"万山之祖"和"亚洲水塔"，其冰川水资源量占全国冰川水资源总量的30%以上。昆仑山的冰川形成于数百万年前，经过漫长的地质变迁和自然过滤，形成了当今世界公认的优质水源地。

昆仑山冰川水具有以下几个显著的健康特征：

一、天然纯净，零污染
昆仑山地处高海拔地区，远离人类活动区域，冰川水在形成过程中未受到任何工业和农业污染。经权威机构检测，昆仑雪冰川水中的重金属、农药残留、微生物等指标均远低于国家标准限值，达到真正意义上的"零污染"。

二、天然弱碱性，平衡体质
昆仑山冰川水经过岩层长期渗透，溶解了适量的矿物质，形成天然的弱碱性水质（pH值7.5-8.0）。长期饮用弱碱性水有助于维持人体酸碱平衡，改善酸性体质。

三、富含多种有益矿物质
冰川水在流经昆仑山岩层的过程中，溶解了丰富的矿物质和微量元素。检测显示，昆仑雪冰川水中含有钙、镁、钾、钠、锶、偏硅酸等多种对人体有益的元素，且比例均衡，易于人体吸收。

四、小分子团结构，更易吸收
科学研究表明，高海拔地区的冰川水具有较小分子团结构，表面张力较低，渗透力更强。这意味着昆仑雪冰川水更容易被人体细胞吸收，补水效率更高。

五、低氘特性，抗衰老
昆仑山冰川水因其特殊的地理环境，具有天然的低氘（D）特性。近年来研究表明，低氘水对延缓衰老、增强细胞活力具有积极作用。

选择昆仑雪，就是选择大自然最珍贵的健康馈赠。每一滴昆仑雪冰川水，都承载着万年雪山的纯净力量，为您的健康保驾护航。`,
    author: '昆仑雪品牌研究院',
    date: '2026-07-15',
    category: '健康科普',
    imageSeq: 'article-glacier-health',
    readTime: '8分钟',
  },
  {
    slug: 'kunlun-snow-brand-story',
    title: '昆仑雪品牌故事：从雪山到瓶中的非凡之旅',
    excerpt: '每一瓶昆仑雪的背后，都是一段从海拔6000米雪山到您手中的非凡旅程。走进昆仑雪的品牌故事，了解这瓶水的传奇诞生。',
    content: `昆仑雪的故事，始于一次深入昆仑山脉腹地的科学考察。

2008年，一支由中国地质科学院和多家科研机构组成的联合考察队深入昆仑山脉，对昆仑山的冰川水资源进行了系统性的科学评估。考察队在海拔6000米以上的冰川区域，发现了多处水质指标远超国际标准的优质水源点。

这些水源点的共同特征是：水源来自万年冰川融水，经过数万年的自然过滤和岩层渗透，水质清冽甘甜，矿物质含量均衡，且完全未受现代工业活动影响。

考察队的发现引起了多位饮用水行业专家的高度关注。经过长达三年的水源跟踪监测、水质稳定性评估和环境影响评价，昆仑雪品牌于2012年正式创立。

昆仑雪的水源地建立了严格的生态保护体系：
- 水源地周围50公里范围内禁止任何工业开发
- 取水口采用无接触式采集技术，确保水源不受污染
- 灌装车间建在海拔3500米处，实现源头灌装
- 全自动无菌生产线，从取水到灌装全程密封

昆仑雪的灌装工厂采用世界领先的全自动无菌灌装技术，从水源采集到成品灌装，全程在密闭管道中完成，杜绝任何外界污染。每一批产品都经过严格的质量检验，确保每一瓶昆仑雪都符合最高的品质标准。

"我们不仅仅是卖一瓶水，更是在传递一种纯净的生活理念和对自然的敬畏之心。"昆仑雪创始人在品牌发布会上如是说。

如今，昆仑雪已成为中国高端矿泉水市场的领军品牌，产品远销海外十多个国家和地区，获得了包括国际品质金奖、亚洲食品创新奖在内的多项国内外大奖。

从雪山到瓶中，昆仑雪的每一段旅程，都承载着对大自然的敬畏和对品质的坚守。`,
    author: '昆仑雪品牌研究院',
    date: '2026-06-20',
    category: '品牌故事',
    imageSeq: 'article-brand-story',
    readTime: '10分钟',
  },
  {
    slug: 'how-to-choose-premium-mineral-water',
    title: '高端矿泉水选购指南：什么才是真正的好水？',
    excerpt: '市面上的矿泉水品牌琳琅满目，价格从几元到上千元不等。如何挑选真正优质的高端矿泉水？这份指南为您揭秘。',
    content: `随着健康意识的提升，越来越多的消费者开始关注饮用水的品质。但面对市场上琳琅满目的矿泉水品牌，很多消费者感到困惑：高端矿泉水究竟"高端"在哪里？如何辨别真正的优质矿泉水？

一、看水源地
水源地是决定矿泉水品质的第一要素。真正的高端矿泉水，其水源地通常具备以下特征：
- 位于高海拔或远离人类活动区域
- 水源地生态环境良好，无工业污染
- 水源经过长时间自然过滤和矿化
昆仑雪的水源地位于昆仑山海拔6000米以上的冰川区域，满足以上所有条件。

二、看矿物质含量
优质矿泉水应含有均衡的矿物质和微量元素。重点关注以下指标：
- 钙（Ca）：有助于骨骼健康
- 镁（Mg）：促进新陈代谢
- 钾（K）：维持电解质平衡
- 锶（Sr）：有益骨骼和牙齿
- 偏硅酸（H₂SiO₃）：有助于皮肤和血管健康
昆仑雪冰川水的矿物质含量均衡，各项指标均在理想范围内。

三、看pH值
人体健康状态下的血液pH值约为7.35-7.45，呈弱碱性。选择天然弱碱性的矿泉水（pH值7.0-8.0），有助于维持人体酸碱平衡。

四、看生产工艺
高端矿泉水应采用源头灌装，避免长途运输原水带来的污染风险。全自动无菌灌装生产线是品质的基本保障。

五、看品牌认证
查看产品是否获得相关质量认证和奖项，这是品质的有力背书。昆仑雪已获得ISO 22000食品安全管理体系认证、HACCP认证等多项权威认证。

记住，真正的好水不仅仅是解渴，更是对健康的投资。选择昆仑雪，就是选择了来自世界屋脊的纯净力量。`,
    author: '昆仑雪品质管理部',
    date: '2026-05-10',
    category: '选购指南',
    imageSeq: 'article-guide',
    readTime: '7分钟',
  },
  {
    slug: 'kunlun-mountain-water-culture',
    title: '昆仑山水文化：中华文明的生命之源',
    excerpt: '昆仑山在中华文化中拥有至高无上的地位，被尊为"万山之祖"。追溯昆仑山水文化的千年历史，感受中华文明与水的深厚渊源。',
    content: `昆仑山，横亘于中国西部，绵延2500余公里，平均海拔5500-6000米，被誉为"万山之祖"和"龙脉之祖"。在中国古代神话和传统文化中，昆仑山是众神居住的神山，是中华文明的发源地之一。

一、神话中的昆仑山
在《山海经》《淮南子》等古籍中，昆仑山被描绘为"帝之下都"，是西王母居住的仙境。传说昆仑山上有不死之泉，饮之可以长生不老。这些神话传说反映了古人对昆仑山水源的崇敬和向往。

二、昆仑山与中华水系
昆仑山的冰川融水是亚洲多条重要河流的发源地，包括黄河、长江、澜沧江等。可以说，昆仑山的冰川水滋养了中华文明。昆仑山因此被称为"亚洲水塔"，其生态地位无可替代。

三、水文化与健康哲学
中国传统文化中，水被赋予极高的哲学地位。老子云："上善若水，水善利万物而不争。"道教文化中，昆仑山的"神水"被视为炼丹制药的必备之物。中医理论认为，优质的水是人体阴阳平衡的基础。

四、现代饮水文化
在当代，随着人们生活水平的提高和健康意识的增强，对饮用水的品质要求也越来越高。昆仑雪传承昆仑山水文化的千年智慧，将这份来自神山的纯净馈赠带给现代消费者。

五、生态保护与可持续发展
昆仑雪深知水源地生态保护的重要性。品牌每年投入大量资源用于昆仑山区域的环境保护和生态修复工作，与当地社区合作，共同守护这片神圣的水源地。

选择昆仑雪，不仅是选择一瓶好水，更是选择了一份对中华水文化的传承和对大自然的敬畏。`,
    author: '昆仑雪文化研究院',
    date: '2026-04-28',
    category: '水文化',
    imageSeq: 'article-culture',
    readTime: '9分钟',
  },
  {
    slug: 'glacier-water-vs-regular-water',
    title: '冰川水与普通矿泉水：五大核心差异',
    excerpt: '冰川水与普通矿泉水究竟有什么不同？从水源、矿物质、分子结构到口感，一文读懂冰川水的独特之处。',
    content: `很多消费者好奇：冰川水和普通矿泉水究竟有什么不同？为什么冰川水的价格更高？本文从五个维度为您详细解析冰川水与普通矿泉水的核心差异。

一、水源差异
普通矿泉水：水源多为地下深层井水或山泉水，取水深度通常在100-500米之间。
冰川水：水源来自高海拔万年冰川融水，经过数万年甚至数十万年的自然形成过程。昆仑雪的冰川水源自昆仑山海拔6000米以上的冰川区域。

二、纯净度差异
普通矿泉水：虽然经过岩层过滤，但仍可能受到一定程度的人为活动影响。
冰川水：形成于人类工业文明之前，水源地远离人类活动区域，水质处于"原始纯净"状态。经检测，昆仑雪冰川水未检出任何农药残留和工业污染物。

三、矿物质含量差异
普通矿泉水：矿物质含量因水源地不同差异较大。
冰川水：经过万年岩层过滤，矿物质溶解充分且比例均衡。昆仑雪冰川水含有钙、镁、钾、锶、偏硅酸等多种有益元素，比例适合人体吸收。

四、分子结构差异
科学研究发现，高海拔冰川水具有较小的分子团结构（通常为5-6个水分子组成的小分子团，普通水为10-15个分子团），这使得冰川水具有更强的渗透力和溶解力，更容易被人体细胞吸收。

五、口感差异
普通矿泉水：口感因矿物质含量不同而异。
冰川水：口感清冽甘甜，入口柔和顺滑，回味悠长。昆仑雪冰川水因其独特的矿物质配比，具有"清、冽、甘、滑"四大口感特征。

总结来说，冰川水在水源、纯净度、矿物质含量、分子结构和口感方面都优于普通矿泉水。选择冰川水，就是选择了更高品质的健康生活。`,
    author: '昆仑雪品质管理部',
    date: '2026-04-05',
    category: '健康科普',
    imageSeq: 'article-compare',
    readTime: '6分钟',
  },
  {
    slug: 'kunlun-snow-international-awards',
    title: '昆仑雪国际荣誉：品质获得全球认可',
    excerpt: '昆仑雪凭借卓越的产品品质和品牌理念，已获得多项国际权威大奖。回顾昆仑雪的荣誉之路，见证中国高端矿泉水品牌的崛起。',
    content: `自2012年创立以来，昆仑雪始终秉持"极致纯净"的品牌理念，以卓越的产品品质赢得了国内外消费者的广泛认可。以下是昆仑雪历年来获得的重要奖项和荣誉：

一、国际品质奖项
- 2024年国际蒙特奖金奖（Monde Selection Gold Award）：国际食品品质评鉴的最高荣誉之一
- 2023年布鲁塞尔国际风味评鉴所三星奖章（iTQi Superior Taste Award）：国际顶级美味大奖
- 2022年亚洲食品创新奖（Asia Food Innovation Award）：表彰昆仑雪在产品创新方面的突出贡献

二、国内权威认证
- 国家地理标志保护产品认证
- ISO 22000食品安全管理体系认证
- HACCP危害分析与关键控制点认证
- 中国绿色食品认证
- 中国有机产品认证

三、行业影响力
- 中国饮用水行业十大影响力品牌
- 中国高端矿泉水市场份额前三名
- 连续五年入选"中国消费者最满意品牌"
- 中国食品工业协会推荐品牌

四、社会责任荣誉
- 昆仑山生态保护贡献奖
- 中国公益企业社会责任奖
- 绿色供应链管理示范企业

每一份荣誉都是对昆仑雪品质的肯定，也是品牌不断前行的动力。未来，昆仑雪将继续坚持品质至上，为全球消费者带来更多源自昆仑山的纯净馈赠。`,
    author: '昆仑雪品牌研究院',
    date: '2026-03-18',
    category: '品牌故事',
    imageSeq: 'article-awards',
    readTime: '5分钟',
  },
];

export const aboutContent = {
  brandIntro: {
    title: '昆仑雪品牌介绍',
    content: `昆仑雪，诞生于2012年，是中国高端矿泉水领域的标杆品牌。品牌灵感源自昆仑山——这座被誉为"万山之祖"和"亚洲水塔"的神圣山脉。

昆仑雪的水源地位于昆仑山脉海拔6000米以上的万年冰川区域。这里远离现代工业文明，保持着地球上最原始、最纯净的自然状态。每一滴昆仑雪都经过数万年的自然过滤和岩层渗透，汲取了丰富的矿物质和微量元素，形成了独特的水质特征：清冽甘甜、天然弱碱、小分子团结构。

昆仑雪始终坚持"极致纯净"的品牌理念，从水源保护、生产灌装到品质检测，每一个环节都追求极致。我们建立了完善的水源地生态保护体系，采用世界领先的无菌灌装技术，确保每一瓶昆仑雪都保持其在雪山之巅时的纯净品质。

十余年来，昆仑雪已从一瓶水发展成为代表中国高端品质生活方式的品牌符号。我们的产品远销海内外，获得了众多国际权威奖项的认可。但无论走得多远，昆仑雪始终不忘初心——将来自世界屋脊的纯净力量，带给每一个追求品质生活的人。`,
  },
  honors: [
    {
      year: '2024',
      title: '国际蒙特奖金奖（Monde Selection）',
      description: '国际食品品质评鉴的最高荣誉，昆仑雪成为中国首个获此殊荣的高端矿泉水品牌。',
    },
    {
      year: '2023',
      title: '布鲁塞尔iTQi三星奖章',
      description: '被誉为食品界的"米其林"，三星为最高等级，国际顶尖美食专家一致好评。',
    },
    {
      year: '2022',
      title: '亚洲食品创新奖',
      description: '表彰昆仑雪在产品创新、包装设计和品牌理念方面的卓越表现。',
    },
    {
      year: '2021',
      title: '中国饮用水行业十大影响力品牌',
      description: '行业权威评选，昆仑雪连续第三年入选。',
    },
    {
      year: '2020',
      title: '中国绿色食品认证',
      description: '获得国家级绿色食品认证，产品品质和环保标准获得官方认可。',
    },
    {
      year: '2019',
      title: '昆仑山生态保护贡献奖',
      description: '表彰昆仑雪在水源地生态保护和可持续发展方面的突出贡献。',
    },
  ],
  contact: {
    address: '新疆维吾尔自治区和田地区昆仑山水源基地',
    phone: '400-888-9999',
    email: 'contact@kunlunsnow.com',
    workingHours: '周一至周五 9:00 - 18:00',
    customerService: '全国统一客服热线：400-888-9999',
  },
};

export const healthValues = [
  {
    icon: 'ri-drop-line',
    title: '极致纯净',
    description: '源自海拔6000米以上万年冰川，远离工业污染，经权威机构检测达到零污染标准，每一滴水保持雪山之巅的原始纯净。',
  },
  {
    icon: 'ri-test-tube-line',
    title: '天然弱碱',
    description: 'pH值7.5-8.0天然弱碱性水质，经过万年岩层自然矿化，有助于维持人体酸碱平衡，改善现代人常见的酸性体质。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '丰富矿物质',
    description: '富含钙、镁、钾、锶、偏硅酸等多种有益矿物质和微量元素，比例均衡，天然配比，易于人体吸收利用。',
  },
  {
    icon: 'ri-flask-line',
    title: '小分子团结构',
    description: '高海拔冰川水具有天然的5-6个小分子团结构，渗透力更强，更容易被人体细胞吸收，补水效率远超普通饮用水。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '低氘特性',
    description: '昆仑山特殊地理环境赋予冰川水天然的低氘（D）特征，科学研究表明低氘水对延缓衰老、增强细胞活力具有积极作用。',
  },
  {
    icon: 'ri-leaf-line',
    title: '生态可持续',
    description: '坚持水源地生态保护，采用环保包装材料，践行绿色可持续发展理念。每一瓶昆仑雪都承载着对大自然的敬意。',
  },
];

export const faqItems = [
  {
    question: '昆仑雪的水源地在哪里？',
    answer: '昆仑雪的水源地位于中国新疆昆仑山脉海拔6000米以上的万年冰川区域，该区域远离工业活动，保持着地球上最原始纯净的自然状态。',
  },
  {
    question: '昆仑雪冰川水与普通矿泉水有什么区别？',
    answer: '昆仑雪冰川水在水源、纯净度、矿物质含量、分子结构和口感五大方面均优于普通矿泉水。它源自万年冰川，经过数万年自然过滤，水质清冽甘甜，富含均衡矿物质，具有小分子团结构，更易被人体吸收。',
  },
  {
    question: '昆仑雪的pH值是多少？',
    answer: '昆仑雪冰川水的pH值在7.5-8.0之间，呈天然弱碱性。长期饮用有助于维持人体酸碱平衡，改善酸性体质。',
  },
  {
    question: '昆仑雪的产品有哪些系列？',
    answer: '昆仑雪目前拥有三大产品系列：冰川之源系列（旗舰级）、雪山灵泉系列（日常健康饮水）、珍藏限量系列（高端收藏级），满足不同消费场景和需求。',
  },
  {
    question: '如何购买昆仑雪产品？',
    answer: '您可以通过昆仑雪官方网站、天猫官方旗舰店、京东自营旗舰店以及全国各大高端商超购买昆仑雪产品。企业定制和团购需求请拨打客服热线 400-888-9999。',
  },
  {
    question: '昆仑雪的生产工艺如何保证水质纯净？',
    answer: '昆仑雪采用源头灌装工艺，灌装工厂建在海拔3500米处，从水源采集到成品灌装全程在密闭管道中完成。全自动无菌灌装生产线，杜绝任何外界污染，确保每一瓶昆仑雪都保持其在雪山之巅的纯净品质。',
  },
];